import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '@components/molecules/Header';
import { Footer } from '@components/molecules/Footer';
import { BreadcrumbsBanner } from '@components/molecules/BreadcrumbsBanner';
import { ContactsSection } from '@components/molecules/ContactsSection';
import { CtaBanner } from '@components/organisms/CtaBanner';
import { GallerySection } from '@components/organisms/GallerySection/GallerySection';
import { useGetBannerPromoteBusiness } from '@services/useGetBannerPromoteBusiness';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { useData } from '@hooks/useData';
import contactsBannerImage from '@assets/images/contacts-banner.jpg';

export const Contacts: FC = () => {
    const { t } = useTranslation();
    const { navigate } = useCustomNavigate();
    const { allSettings } = useData();
    const { banner, request: fetchBanner, loading: bannerLoading } = useGetBannerPromoteBusiness();

    const translations = {
        title: t('contacts-component.title'),
        bannerPromoteBusinessAlt: t('contacts-component.banner.promote-business-alt'),
    };

    useEffect(() => {
        fetchBanner();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleBannerClick = () => {
        if (banner?.content_banner_promote_business_link) {
            navigate(banner.content_banner_promote_business_link);
        }
    };

    const headerImage = (allSettings?.data as any)?.content_headers_contacts_image || contactsBannerImage;

    return (
        <>
            <Header variant="default" />

            <BreadcrumbsBanner
                title={translations.title}
                currentPage={translations.title}
                image={headerImage}
            />

            <ContactsSection />

            {!bannerLoading && banner && (
                <CtaBanner
                    variant="background"
                    subtitle={banner.content_banner_promote_business_subtitle}
                    title={banner.content_banner_promote_business_title || ''}
                    description={banner.content_banner_promote_business_description}
                    buttonText={banner.content_banner_promote_business_button_text}
                    onButtonClick={handleBannerClick}
                    imageUrl={banner.content_banner_promote_business_image}
                    imageAlt={banner.content_banner_promote_business_title || translations.bannerPromoteBusinessAlt}
                />
            )}

            <GallerySection />

            <Footer mode="normal" />
        </>
    );
};
